import { imageFieldsFrag } from '@/service/fragments/imageFieldsFrag'
import { gql } from '@/service/gql'
import type { ResultOf } from 'gql.tada'
import { playableEntityFrag } from '@/service/fragments/playableEntityFrag'
import type { SanitizedGql } from '@/util/gqlUtil'

// language=GraphQL
export const playlistFieldsFrag = gql(
    `
        fragment playlistFields on Playlist @_unmask {
            ...playableEntity
            id
            _type
            title
            url
            sharingUrl
            visibility
            description
            contributors
            curator @include(if: $isAuthenticated) {
                id
                name
            }
            images {
                ...imageFields
            }
            trackCount
            duration
        }
    `,
    [imageFieldsFrag, playableEntityFrag]
)

export type PlaylistFields = SanitizedGql<ResultOf<typeof playlistFieldsFrag>>
